import React, { FC } from 'react';
import Select, {
  ClassNamesConfig,
  components,
  DropdownIndicatorProps,
  GroupBase,
  SingleValue,
} from 'react-select';

// Interfaces
import { InputSelectOption } from '../interfaces/Input';

// Components
import { ErrorMessage } from './ErrorMessage';

interface Props {
  label?: string;
  value: string;
  choices: InputSelectOption[];
  onChange: (value: string | undefined) => void;
  placeholder?: string;
  errorMessage?: string;
  className?: string;
  wrapperClassName?: string;
}

const DropdownIndicator = <Option, IsMulti extends boolean = false>(
  props: DropdownIndicatorProps<Option, IsMulti, GroupBase<Option>>
) => {
  const { menuIsOpen } = props.selectProps;

  return (
    <components.DropdownIndicator {...props}>
      <svg
        className="icon"
        style={{
          transform: menuIsOpen ? 'rotate(0deg)' : 'rotate(180deg)',
          transition: 'transform 0.2s ease-in-out',
        }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="none"
        width="16"
        height="16"
      >
        <path
          d="M3 10.9624L7.825 6.13735C7.8685 6.09381 7.92013 6.05927 7.97694 6.0357C8.03381 6.01213 8.09475 6 8.15625 6C8.21775 6 8.27869 6.01213 8.33556 6.0357C8.39238 6.05927 8.444 6.09381 8.4875 6.13735L13.3125 10.9624"
          stroke="#505050"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

const FormikDropdown: FC<Props> = ({
  value,
  label,
  placeholder,
  errorMessage,
  className,
  wrapperClassName,
  choices = [],
  onChange,
}) => {
  className = `aea-form-dropdown ${className || ''}`;

  const handleChange = (newValue: SingleValue<InputSelectOption>) => {
    onChange(newValue?.value as string);
  };
  const getValue = () => {
    if (value) {
      return choices.find((option) => option.value === value);
    } else {
      return null;
    }
  };

  const customClassNames = {
    control: () => 'react-select__control',
    menu: () => 'react-select__menu',
    menuList: () => 'react-select__menu-list',
    option: (state: any) => `react-select__option ${state.isFocused ? 'react-select__option--focused' : ''} ${state.isSelected ? 'react-select__option--selected' : '' }`,
    valueContainer: () => 'react-select__value-container',
    indicatorsContainer: () => 'react-select__indicators-container',
  };

  return (
    <div className={`react-select-wrapper ${wrapperClassName || ''}`}>
      {label && <label className='form-label'>{label}</label>}
      <Select
        placeholder={placeholder}
        options={choices}
        onChange={handleChange}
        value={getValue()}
        isSearchable={false}
        components={{
          IndicatorSeparator: () => null,
          DropdownIndicator: (props) => <DropdownIndicator {...props} />,
        }}
        blurInputOnSelect={false}
        // menuIsOpen={true}
        classNames={customClassNames}
      />
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </div>
  );
};

export default FormikDropdown;
